export enum GetQuery {
    //COMPANY
    //Styles
    GET_BRANDS_NO_IDS = `
    query Brands ($companyId: Int!, $search: String) {
        brands(
            where: {
                companyId: { eq: $companyId }
                brand: {
                    active: { eq: true }
                    cancelled: { eq: false }
                    name: { contains: $search }
                }
            }
            order: { brand: {name: ASC} }
        ) {
            nodes {
                brandId
                hasSizeGroup
                brand {
                    name
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_BRANDS = `
    query Brands ($companyId: Int!, $brandIds: [Int!], $search: String) {
        brands(
            where: {
                companyId: { eq: $companyId }
                brand: {
                    active: { eq: true }
                    cancelled: { eq: false }
                    id: { in: $brandIds }
                    name: { contains: $search }
                }
            }
            order: { brand: {name: ASC} }

        ) {
            nodes {
                brandId
                hasSizeGroup
                brand {
                    name
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_CATEGORIES_ALL = `
    query Category($search: String) {
        category(
        where: {name: {contains: $search}}
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_CATEGORIES_NO_IDS = `
    query Category($brandIds:[Int]!) {
        category(
            where: { styles: { some: { brandId: { in: $brandIds } } } }
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_CATEGORIES_BY_IDS = `
    query Category($categoryIds: [Int!]) {
        category(
        where: { id: { in: $categoryIds }}
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
        }
    }
    `,
    GET_PHOTOGRAPHERS = `
    query Photographers($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $statusIds:[IdsInput!]!, $photographerIds:[IdsInput!]) {
        photographers(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            statusIds: $statusIds
            photographerIds: $photographerIds
            ) {
                nodes {
                    active
                    statusId
                    statusName
                    statusColor
                    companyId
                    companyName
                    shotCost
                    totalPaid
                    monthlyPaid
                    maxItems
                    discountThreshold
                    discountPercentage
                    hiredFrom
                    hiredUntil
                    automaticRenewal
                    personId
                    firstName
                    lastName
                    fullName
                    brands {
                        brandId
                        brandName
                        hasSizeGroup
                        personId
                        categories {
                            personId
                            brandId
                            categoryId
                            categoryName
                        }
                    }
                }
            }
        }
    `,
    GET_WAREHOUSES_NO_IDS = `
    query Warehouses($first: Int, $after: String, $search: String) {
        warehouses(
            first: $first, after: $after, 
            where: { or: [{code: { contains: $search }}, {description: { contains: $search }}]}
            order: { code: ASC, description: ASC }
        ) {
            nodes {
                code
                description
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_WAREHOUSES = `
    query Warehouses($first: Int, $after: String, $search: String, $warehouseIds: [Int!]) {
        warehouses(first: $first, after: $after, 
            where: { 
                or: [{code: { contains: $search }}, {description: { contains: $search }}]
                id:{ in: $warehouseIds}
            }
            order: { code: ASC, description: ASC }
        ) {
            nodes {
                code
                description
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_STYLE_GROUPS_NO_IDS = `
    query StyleGroups($first: Int, $after: String, $search: String) {
        styleGroups(first: $first, after: $after, 
        where: { name: { contains: $search }}
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_STYLE_GROUPS = `
    query StyleGroups($first: Int, $after: String, $search: String, $styleGroupIds: [Int!]) {
        styleGroups(
            first: $first, after: $after, 
            where: { name: { contains: $search }, id:{ in: $styleGroupIds}}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_SIZE_GROUPS_NO_IDS = `
    query SizeGroups($search: String) {
        sizeGroups(
            order: { ord: ASC }
            where: { or: [{ active: { eq: true } }, { cancelled: { eq: false } }], and: {name: {contains: $search}} }
        ) {
            nodes {
                id
                name
            }
        }
    }
    `,
    GET_SIZE_GROUPS = `
    query SizeGroups($sizeGroupIds: [Int]) {
        sizeGroups(where: { id: { in: $sizeGroupIds } }) {
            nodes {
                id
                name
            }
        }
    }
    `,
    GET_SIZE_GROUPS_BY_BRAND = `
    query SizeGroupsByBrand($brandId: Int!) {
        sizeGroupsByBrand(brandId: $brandId) {
            nodes {
                id
                name
            }
        }
    }
    `,
    GET_STYLE_DESCRIPTIONS_NO_IDS = `
    query StyleDescriptions($first: Int, $after: String, $search: String) {
        styleDescriptions(
            first: $first, after: $after, 
            where: { name: { contains: $search }}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_STYLE_DESCRIPTIONS = `
    query StyleDescriptions($first: Int, $after: String, $search: String, $styleDescriptionIds: [Int!]) {
        styleDescriptions(
            first: $first, after: $after, 
            where: { name: { contains: $search }, id:{ in: $styleDescriptionIds}}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_PURPOSES_NO_IDS = `
    query Purposes($first: Int, $after: String, $search: String) {
        purposes(
            first: $first, after: $after, 
            where: { name: { contains: $search }}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_PURPOSES = `
    query Purposes($first: Int, $after: String, $search: String, $purposeIds: [Int!]) {
        purposes(
            first: $first, after: $after, 
            where: { name: { contains: $search }, id:{ in: $purposeIds}}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_TEAMS_NO_IDS = `
    query Teams($first: Int, $after: String, $search: String) {
        teams(
            first: $first, after: $after, 
            where: { or: [{code: { contains: $search }}, {name: { contains: $search }}]}
            order: { name: ASC }
        ) {
            nodes {
                id
                code
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_TEAMS = `
    query Teams($first: Int, $after: String, $search: String, $teamIds: [Int!]) {
        teams(
            first: $first, after: $after, 
            where: { or: [{code: { contains: $search }}, {name: { contains: $search }}] id:{ in: $teamIds}}
            order: { name: ASC }
        ) {
            nodes {
                id
                code
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_SUGGESTED_SEASONS_NO_IDS = `
    query SuggestedSeasons {
        suggestedSeasons(
            order: { name: ASC }
        ) {
            nodes {
                id
                name
                winter
                fall
                summer
                spring
            }
        }
    }
    `,
    GET_SUGGESTED_SEASONS = `
    query SuggestedSeasons($seasonIds: [Int!]) {
        suggestedSeasons(
            where: { id: { in: $seasonIds} }
            order: { name: ASC }
        ) {
            nodes {
                id
                name
                winter
                fall
                summer
                spring
            }
        }
    }
    `,
    GET_COMPANY_STYLES = `
    query CompanyStyles($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $notAssigned: Boolean!, $brandIds: [IdsInput!]!, $categoryIds: [IdsInput!]!, $photographersIds: [IdsInput!]!, $warehousesIds: [IdsInput!]!, $styleGroupIds: [IdsInput!]!, $styleDescriptionIds: [IdsInput!]!, $purposeIds: [IdsInput!]!, $teamIds: [IdsInput!]!, $suggestedSeasonIds: [IdsInput!]!) {
        companyStyles(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            notAssigned: $notAssigned
            brandIds: $brandIds
            categoryIds: $categoryIds
            photographersIds: $photographersIds
            warehousesIds: $warehousesIds
            styleGroupIds: $styleGroupIds
            styleDescriptionIds: $styleDescriptionIds
            purposeIds: $purposeIds
            teamIds: $teamIds
            suggestedSeasonIds: $suggestedSeasonIds
        ) {
            nodes {
                total
                datasource {
                    brandId
                    brandName
                    categoryId
                    categoryName
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                    warehouses {
                        modelId
                        warehouseId
                        warehouseCode
                        warehouseDescription
                        warehouseFullName
                    }
                    ordersInfo {
                        modelId
                        photographerId
                        orderId
                        orderNumber
                        firstName
                        lastName
                        photographerFullName
                    }
                }
            }
        }
    }
    `,
    GET_COMPANY_STYLE_DETAILS = `
    query CompanyStyleDetails($currentUserId: Int!, $modelId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $colorIds: [Int!]!, $sizeGroupIds: [Int!]!) {
        companyStyleDetails(
            currentUserId: $currentUserId
            modelId: $modelId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            colorIds: $colorIds
            sizeGroupIds: $sizeGroupIds
        ) {
             nodes {
                colorsRowsLength
                style {
                    hasSizeGroup
                    brandId
                    brandName
                    categoryId
                    categoryName
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                }
                detailsRows {
                    sizeGroupId
                    sizeGroupName
                    photoSessionStatus
                    totalShots
                    approvedShots
                    colorId
                    colorCode
                    colorName
                    fullName
                    shots {
                        imgPath
                        shotTypeCode
                        shotTypeName
                        shotTypeId
                        sizeGroupId
                        sizeGroupName
                        colorId
                        ord
                        shotId
                        stateId
                        stateDescription
                    }
                }
            }
        }
    }
    `,
    //OrderList
    GET_COMPANY_ORDERS = `
    query CompanyOrders ($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $filters: OrdersListFiltersInput!) {
        companyOrders(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            filters: $filters
        ) {
            nodes {
                total
                orders {
                    photographerPersonId
                    photographerFullName
                    orderId
                    orderNumber
                    orderStatusId
                    orderStatusName
                    dueDate
                    approvedShots
                    totalShots
                }
            }
        }
    }
    `,
    GET_ORDER_STATUSES_NO_IDS = `
    query OrderStatuses {
        orderStatuses {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_ORDER_STATUSES = `
    query OrderStatuses($ids: [Int]) {
        orderStatuses(where: { id: { in: $ids } }) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_COLORS_BY_MODEL = `
    query Colors($first: Int, $after: String, $modelId: Int!, $search: String) {
        colors(
            first: $first
            after: $after
            where: { schemaTeamColors: { some: { schema: { modelId: { eq: $modelId } } } }             
                or: [
                    { code: { contains: $search } }
                    { finalColorName: { contains: $search } }
                ]
            }
        ) {
            nodes {
                id
                code
                finalColorName
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
    GET_COLORS_BY_IDS = `
    query Colors($colorIds: [Int]!) {
        colors(where: { id: { in: $colorIds } }) {
            nodes {
                id
                code
                name
                finalColorName
            }
        }
    }
    `,
    GET_COMPANY_ORDER_DETAILS = `
    query CompanyOrderDetails($orderId: Int!, $companyId: Int!) {
        companyOrderDetails(orderId: $orderId, companyId: $companyId) {
            nodes {
                colorsRowsLength
                orderStatus {
                    statusId
                    statusName
                }
                orderDetails {
                    modelId
                    styleCode
                    styleName
                    fullName
                    completed
                    styleStatus
                    brandId
                    brandName
                    firstName
                    lastName
                    photographerFullName
                    colorCode
                    colorName
                    colorId
                    sizeGroupId
                    sizeGroupName
                }
            }
        }
    }
    `,
    GET_PHOTOGRAPHER_STATUS_NO_IDS = `
    query PhotographerStatus {
        photographerStatus {
            nodes {
                id
                tag
                name
                description
                isCompanySelectable
                color
            }
        }
    }
    `,
    GET_PHOTOGRAPHER_STATUS = `
    query PhotographerStatus($statusIds: [Int]) {
        photographerStatus(where: { id: { in: $statusIds } }) {
            nodes {
                id
                tag
                name
                description
                isCompanySelectable
                color
            }
        }
    }
    `,
    // DASHBOARD
    GET_PRODUCTS = `
    query Products($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!) {
        products(companyId: $companyId, paginationPage: $paginationPage, paginationSize: $paginationSize) {
            nodes {
                products {
                    modelId
                    styleCode
                    styleName
                    styleFullName
                    orderId
                    orderNumber
                    dueDate
                    personId
                    firstName
                    lastName
                    photographerFullName
                }
                total
            }
        }
    }
    `,
    GET_COMPANY_DASHBOARD = `
    query CompanyDashboard($companyId: Int!) {
        companyDashboard(companyId: $companyId) {
            nodes {
                activePhotographers {
                    active
                    total
                }
                noImageItemsData {
                    active
                    onHold
                    total
                    activePerc
                    onHoldPerc
                }
                databaseStatusData {
                    withImg
                    withoutImg
                    total
                    withImgPerc
                    withoutImgPerc
                }
            }
        }
    }
    `,
    GET_PHOTOGRAPHER_STATUS_REQUESTED = `
    query PhotographersStatusRequested {
        photographersStatusRequested(where: { stateTag: { eq: "Requested" } }) {
            nodes {
                personId
                firstName
                lastName
            }
        }
    }
    `,
    // Templates
    GET_ASPECT_RATIOS = `
    query AspectRatios {
        aspectRatios(where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
    GET_MEDIA_FORMATS = `
    query MediaFormats {
        mediaFormats(where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
    GET_CODIFIED_USEDS = `
    query CodifiedUseds($search: String) {
        codifiedUseds(
            where: {
                active: { eq: true }
                or: [{ code: { contains: $search } }, { description: { contains: $search } }]
            }
        ) {
            nodes {
                id
                code
                description
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
    GET_TEMPLATES = `
    query Templates($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $brandIds: [Int!]!, $categoryIds: [Int!]!) {
        templates(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            brandIds: $brandIds
            categoryIds: $categoryIds
        ) {
            nodes {
                parentTemplateId
                templateName
                companyId
                brandId
                brandName
                categoryId
                categoryName
                hasSizeGroup
                shotTypes {
                    parentTemplateId
                    sizeGroupName
                    sizeGroupId
                    shotTypeId
                    shotTypeCode
                    shotTypeName
                    ord
                    aspectRatioId
                    mediaFormatId
                    codifiedUsedId
                }
                styles {
                    parentTemplateId
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                }
                colors {
                    parentTemplateId
                    colorId
                    colorCode
                    colorName
                    fullName
                }
            }
        }
    }
    `,
    GET_CATEGORY_STYLE = `
    query CategoryStyle($brandId: Int!, $categoryId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!) {
        categoryStyle(
            brandId: $brandId
            categoryId: $categoryId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
        ) {
            nodes {
                modelId
                styleCode
                styleName
                fullName
                sketchImgPath
            }
        }
    }
    `,
    GET_SHOT_TYPES = `
    query ShotTypes($first: Int, $after: String, $search: String) {
        shotTypes(first: $first, after: $after, order: {code: ASC}
        where: {             
                or: [
                    { code: { contains: $search } }
                    { name: { contains: $search } }
                ]
            }
        ) {
            nodes {
                id
                code
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,

    //PHOTOGRAPHER
    //Order List
    GET_PHOTOGRAPHER_ORDERS = `
    query PhotographerOrders($photographerId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $onGoing: Boolean!, $filters: OrdersListFiltersInput!) {
        photographerOrders(
            photographerId: $photographerId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            onGoing: $onGoing
            filters: $filters
        ) {
            nodes {
                orders {
                    orderId
                    orderNumber
                    orderStatusId
                    orderStatusName
                    dueDate
                    approvedShots
                    totalShots
                }
                total
            }
        }
    }
    `

};